import React from 'react';
import { isNil } from 'lodash';

import MenuItem from '~/components/core/Atomic/MenuItem';
import TextFieldFormik from '~/components/TextFieldFormik';

import { useReportTemplates } from '../ReportTemplates/hooks/useReportTemplates';

import { SHARED_EXPORT_TEXTS } from './texts';

interface ReportTemplateSelectProps {
  id?: string;
  label?: string;
  disabled?: boolean;
}

const ReportTemplateSelect: React.FC<ReportTemplateSelectProps> = ({
  id = 'report_template_id',
  label = SHARED_EXPORT_TEXTS.REPORT_TEMPLATE_LABEL,
  disabled = false,
}) => {
  const { templates, isLoading: isLoadingTemplates } = useReportTemplates();

  const activeTemplates = templates.filter((template) => template.is_active);

  return (
    <TextFieldFormik id={id} label={label} fullWidth select disabled={disabled || isLoadingTemplates}>
      {/* @ts-expect-error TextFieldFormik types don't support MenuItem children when used as select */}
      {activeTemplates.length === 0 ? (
        <MenuItem value="" disabled>
          {SHARED_EXPORT_TEXTS.REPORT_TEMPLATE_NO_TEMPLATES}
        </MenuItem>
      ) : (
        activeTemplates
          .filter((template) => !isNil(template.id))
          .map((template) => (
            <MenuItem key={template.id} value={template.id as number}>
              {template.name}
            </MenuItem>
          ))
      )}
    </TextFieldFormik>
  );
};

export default ReportTemplateSelect;
